module.exports = __webpack_public_path__ + "/hashedassets-launcher/launcher_meetings_new2.00b9fe3a1ebee92c0955dc4956f774d0.svg";